export default __webpack_public_path__ + "./image/daf0c5316b0483593d41ebd88bbf9de1.png";